import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { ParametrizacaoListComponent } from './pages/parametro-list/parametrizacao-list.component';
import { ParametrizacaoFormComponent } from './pages/parametro-form/parametrizacao-form.component';
import { ParametrizacaoSharedDataService } from './parametrizacao-shared-data.service';
import { ParametrizacaoRoutingModule } from './parametrizacao-routing.module';

@NgModule({
  declarations: [
    ParametrizacaoListComponent,
    ParametrizacaoFormComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    SharedModule,
    ParametrizacaoRoutingModule,
    NgxPermissionsModule.forChild(),
    NgxMaskDirective,
    NgxMaskPipe
  ],
  providers: [
    ParametrizacaoSharedDataService
  ]
})
export class ParametrizacaoModule { }

